// Shared inline styles for the sidebar panels (same look as tabbedSidebar).
const styles = {
    root: { display: 'flex', flexDirection: 'column', gap: '18px' },
    sectionLabel: {
        fontSize: '11px',
        color: '#888',
        textTransform: 'uppercase',
        letterSpacing: '1px',
        marginBottom: '8px',
    },
    grid3: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '6px' },
    optionBtn: (isActive) => ({
        position: 'relative',
        padding: '10px 4px',
        background: isActive ? '#2a2a2a' : '#1a1a1a',
        border: isActive ? '2px solid #ecff19' : '2px solid #333',
        borderRadius: '6px',
        color: isActive ? '#ecff19' : '#aaa',
        fontSize: '11px',
        fontWeight: isActive ? 600 : 400,
        cursor: 'pointer',
        textAlign: 'center',
        transition: 'border-color 0.15s, color 0.15s',
    }),
    checkMark: {
        position: 'absolute',
        top: '3px',
        right: '4px',
        fontSize: '8px',
        color: '#ecff19',
        lineHeight: 1,
    },
    slotRow: { display: 'flex', gap: '10px', marginBottom: '10px', flexWrap: 'wrap' },
    slotWrap: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px' },
    slotBtn: (color, isActive) => ({
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        backgroundColor: color,
        border: isActive ? '3px solid #ecff19' : '3px solid transparent',
        outline: isActive ? '1px solid #555' : '1px solid #333',
        boxSizing: 'border-box',
        cursor: 'pointer',
        flexShrink: 0,
        transition: 'border-color 0.15s',
    }),
    slotLabel: { fontSize: '10px', color: '#666', textAlign: 'center' },
    note: { fontSize: '11px', color: '#555', fontStyle: 'italic' },
    divider: { borderTop: '1px solid #2a2a2a', margin: '0 0 2px' },
};

export default styles;
